import * as React from 'react';
import theme from '../theme/theme';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import CircularProgress, {
  circularProgressClasses,
} from '@mui/material/CircularProgress';

import cp from '../assets/img/cp.png'

// Inspired by the former Facebook spinners.
function FacebookCircularProgress(props) {
  return (
    <Box sx={{ position: 'relative'}}>
      <CircularProgress
        variant="determinate"
        sx={(theme) => ({
          color: theme.palette.grey[100],
        })}
        size={100}
        thickness={5}
        {...props}
        value={100}
      />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        sx={(theme) => ({
          color: theme.palette.grey[200],
          animationDuration: '550ms',
          position: 'absolute',
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round',
          },
        })}
        size={100}
        thickness={5}
        {...props}
      />
    </Box>
  );
}


const CircularProgressCP = ({}) => {

  return (
    <Box sx={{
      backgroundImage:`url(${cp})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: 'center',
      backgroundSize: '50px',
      //height: "50px",
      }}>
      <FacebookCircularProgress />
    </Box>
  );
};
export default CircularProgressCP;